import React, { Fragment } from 'react';
import { Flex } from '@withjoy/joykit';
import { JoyLogoLoader } from '@shared/components/JoyLogoLoader';

import { RichText } from './components/RichText';
import { TravelMap } from './components/TravelMap';
import { useCustomData } from './hooks/useCustomData';

interface Props {
  pageId: string;
  eventId: string;
  pageSlug: string;
  eventHandle: string;
  pageTitle?: string;
  subTitle?: string | null;
  isBrannanLayout?: boolean;
}

export const Custom: React.FC<Props> = props => {
  const { pageSlug, eventId, eventHandle } = props;
  const { loading, pageContainerBySlug } = useCustomData(eventId, eventHandle, pageSlug);

  if (loading) {
    return <JoyLogoLoader loaderKey="guest-custom-page" />;
  }

  return (
    <Flex flexDirection={'column'} width={'100%'}>
      {pageContainerBySlug?.components?.map(component => (
        <Fragment key={component.id}>
          {/* @todo - Need to persist component order - https://withjoy.atlassian.net/browse/CORE-5551 */}
          {component.__typename === 'TextComponent' && <RichText richTextComponentData={component} />}
          {component.__typename === 'TravelMapComponent' && <TravelMap {...props} travelMapComponentData={component} />}
        </Fragment>
      ))}
    </Flex>
  );
};
